import backgroundBenchmark from "@images/backgroundBenchmark.png"
import InvitationIcon from "@images/invitationIcon.svg"
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"
import errorInvitationShareCoach from "@images/error/errorInvitationShareCoach.svg"
import { word } from "@modules/core/utils/i18n"

export function MemberOfferInvitationError({ className }: React.ComponentProps<"div">) {
  const theme = useTheme()
  const defaultClassName = "flex flex-column gap-4"

  return (
    <div className={className ?? defaultClassName} style={{ height: "90vh" }}>
      {/* HEADER */}
      <div
        className="relative flex h-15rem bg-neutral-200 border-round-bottom-3xl"
        style={{ marginTop: "-85px", marginRight: "-20px", marginLeft: "-20px" }}
      >
        <div className="flex flex-column justify-content-center align-items-center w-6 h-full mt-2 ml-1 gap-2">
          <div
            className="bg-contain bg-no-repeat bg-center"
            style={{ backgroundImage: `url('${InvitationIcon} ')`, width: "60px", height: "60px" }}
          ></div>
          <HUText fontStyle="HM" color={theme.neutralColor900}>
            {word("member.offer.invitationError.title")}
          </HUText>
          <HUText fontStyle="BM" color={theme.neutralColor900}>
            {word("member.offer.invitationError.subtitle")}
          </HUText>
        </div>
        <div
          className="bg-cover bg-no-repeat bg-right h-full w-6"
          style={{
            background: `url('${backgroundBenchmark}')`,
            clipPath: "polygon(43% 0, 100% 0, 100% 100%, 0% 100%)",
            WebkitClipPath: "polygon(43% 0, 100% 0, 100% 100%, 0% 100%)",
          }}
        ></div>
      </div>
      {/* CONTENT */}
      <div className="flex flex-column align-items-center justify-content-center bg-neutralColor-100 rounded-card flex-grow-1 gap-2">
        <HUText fontStyle="TM" color={theme.neutralColor700}>
          {word("member.offer.invitationError.content")}
        </HUText>
        <HUText fontStyle="BM" color={theme.neutralColor900} className="text-center w-8">
          {word("member.offer.invitationError.subcontent")}
        </HUText>
        <div
          className="flex w-full h-12rem bg-contain bg-no-repeat bg-center  "
          style={{ backgroundImage: `url(${errorInvitationShareCoach})` }}
        ></div>
      </div>
    </div>
  )
}
